import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './patientHome.module.scss';
import  { ApiCore } from '../../../api/index';
import { Modal } from 'antd-mobile-v5';
import patient_home_avatar from '../../../static/images_doctor/patient_home_avatar.png';
import patient_home_avatar_bg from '../../../static/images_doctor/patient_home_avatar_bg.png';
import followup_node_icon from '../../../static/images_doctor/followup_node_icon.png';
import right_arrow from '../../../static/images/rightArrow.png';
import utils from '../../../utils/utils';
import PatientHomeDetail from './patientHomeDetail';
import InformedArchives from './informedArchives';
import BasicArchives from './basicArchives';
import { Tabs } from 'antd-mobile';
import CRFComponent from '../../../component/crf/crf';
import OutcomeRegister from '../../../static/images_doctor/outcome_register.png';
import IconPlay from '../../../static/images_doctor/icon-play.png';
import { Toast } from 'antd-mobile';

const api = new ApiCore();

function Personal(props: any) {

    const [tabPage, setTabPage] = useState(0);
    const [initIndicatorCurIndex, setInitIndicatorCurIndex] = useState(2);
    const [indicatorCurIndex, setIndicatorCurIndex] = useState(0);
    const [followupList, setFollowupList] = useState([{},{},{},{},{}]);
    const [nodeList, setNodeList] = useState<any>([]);
    const [headTabs, setHeadTabs] = useState([{
        title: '患者首页'
    }, {
        title: '基础档案'
    }, {
        title: '知情档案'
    }, {
        title: ''
    }, {
        title: ''
    }]);
    const refDom = useRef<any>(null);
    const [detailData, setDetailData] = useState<any>({});
    const [patientStateMap, setPatientStateMap] = useState<any>({});
    const [showCrf, setShowCrf] = useState(false);
    const [tenantCode, setTenantCode] = useState('');

    const [formData, setFormData] = useState<any>({});

    const CrfRef: any = useRef();

    useEffect(() => {
        document.title = '患者首页';
        initData();
        return () => {
        }
    }, [])

    const history = useHistory();

    const initData = () => {
        const _urlParam = utils.getUrlParams() || {};
        const mPatientStateMap = sessionStorage.getItem('PatientStateMap');
        try {
            mPatientStateMap && setPatientStateMap(JSON.parse(mPatientStateMap));
        } catch (error) {
        }
        setShowCrf(false);
        api.getCaseDetail(_urlParam.caseCode).then((res: any) => {
            if (res.code == 0) {
                const _data = res.data || {};
                setDetailData(_data);
                setNodeList(_data.events || []);
                setTenantCode(_data.tenantCode);
                let _formInfo = _data.events[0].tasks[0];
                let _formParam = {
                    crfVersion: _formInfo.formVersion,
                    crfCode: _formInfo.formCode,
                    recordCode: _formInfo.code,
                    tenantCode: _data.tenantCode
                }
                if (props.onShow) {
                    sessionStorage.setItem('CrfReqParam', JSON.stringify(_formParam));
                    props.onShow(_formParam);
                    setTimeout(() => {
                        setShowCrf(true);
                    }, 200)
                }
            }
        });
    }


    const toolIntroduceClick = (index: any, tab: any) => {
            if (index <= 2) {
                setTabPage(index);
            }
    }

    const followupCardScroll = (event: any) => {
    }

    const nodeListActive = (index: number) => {
        setIndicatorCurIndex(index)
        setShowCrf(false);
        let _formInfo = nodeList[index].tasks[0] || {};
        let _formParam = {
            crfVersion: _formInfo.formVersion,
            crfCode: _formInfo.formCode,
            recordCode: _formInfo.code,
            tenantCode: tenantCode
        }
        // if (props.onShow) {
        //     sessionStorage.setItem('CrfReqParam', JSON.stringify(_formParam));
        //     props.onShow(_formParam);
        //     setTimeout(() => {
        //         setShowCrf(true);
        //     }, 200)
        // }
    }

    const nodeListItemClick = (val: any, index: number) => {
        const _node = nodeList[indicatorCurIndex];
        const _param = {
            caseCode: detailData.caseCode,
            tenantCode: detailData.tenantCode,
            channel: 'EDC',
            // eventCode: _node.code, // 节点code
            // nodeState: _node.state,
            // taskCode: val.code,
            event: _node,
            task: val
        }
        sessionStorage.setItem('PatientHomeDetailData', JSON.stringify(_param));
        history.push('/doctor/patientHomeDetail');
    }

    // const _node = nodeList[indicatorCurIndex];
    // const _task = nodeList[indicatorCurIndex][0];
    // const _patientHomeDetailData = {
    //     caseCode: detailData.caseCode,
    //     tenantCode: detailData.tenantCode,
    //     eventCode: _node.code,
    //     state: _node.state,
    //     taskCode: _task.code,
    //     ..._task
    // };

    const renderOutcome = (data: any = {}) => {
        let _token: any = {};
        try {
            _token = JSON.parse(sessionStorage.getItem('token') || '{}');
        } catch (error) {
            _token = {};
        }
        let _formData = {
            channel: 'EDC',
            tenantCode: detailData.tenantCode,
            caseCode: detailData.caseCode,
            // eventCode: _formData.event.code,
            crfVersion: data.formVersion,
            crfCode: data.formCode,
            recordCode: data.recordCode,
            userCode: _token.userCode
        };
        setFormData(_formData);
        return (
        <div className={`${styles.outcome_content}`}>
            <div className={`${styles.outcome_content_in}`}>
                <CRFComponent
                    ref={CrfRef}
                    params={_formData}
                    onSaveSuccess={(v: any) => onSaveSuccess(v)}
                />
            </div>
            <div className={`${styles.outcome_bottom}`}>
                <div>返回</div>
                <div>完成</div>
            </div>
        </div>)
    }

    /**
     * 保存表单内容
     */
    const handleSave = () => {
        CrfRef.current.handleSave()
    }

    const onSaveSuccess = (savedData: any) => {

    };

    const showOutCome = () => {
        if (!detailData.caseCode) {
            return;
        }
        api.getCaseTransferFileInfo({
            caseCode: detailData.caseCode
        }).then((res: any) => {
            if (res.code == 0) {
                let _token: any = {};
                try {
                    _token = JSON.parse(sessionStorage.getItem('token') || '{}');
                } catch (error) {
                    _token = {};
                }
                const _data = res.data || {};
                let outcomeForm = {
                    channel: 'EDC',
                    tenantCode: detailData.tenantCode,
                    caseCode: detailData.caseCode,
                    // eventCode: '',
                    crfVersion: _data.formVersion,
                    crfCode: _data.formCode,
                    recordCode: _data.recordCode,
                    userCode: _token.userCode
                };
                sessionStorage.setItem('OutComeRegisterData', JSON.stringify(outcomeForm));
                history.push('/doctor/outComeRegister');
                // OutComeRegisterData
                //     Modal.show({
                //         bodyClassName: 'patientHomeOutCome',
                //         content: renderOutcome(res.data || {}),
                //         showCloseButton: true,
                //         closeOnMaskClick: true,
                //     })
            } else {
                Toast.fail(res.message || '服务异常', 0.8);
            }
        });
    }

    return (
        <div className={`${styles.patientHome_content}`}>
            {
                <Tabs tabs={headTabs}
                    initialPage={0}
                    page={tabPage}
                    swipeable={false}
                    onTabClick={(tab, index) => { toolIntroduceClick(index, tab); }}
                    tabBarUnderlineStyle={{ display: 'none' }}
                >
                    <div className={`${styles.content_wrap}`}>
                        <div className={`${styles.content_wrap_top}`}>
                            <div className={styles.home_avatar_container} style={{backgroundImage: `url(${patient_home_avatar_bg})`, backgroundSize: '100% 100%'}}>
                                <img className={styles.home_avatar} src={patient_home_avatar} alt="" />
                                <div className={styles.home_head_container}>
                                    <div className={styles.home_head_wrap} > 
                                        <span className={styles.head_title} >{detailData.patientName}</span> 
                                        {/* <span className={styles.head_referral} >已转诊</span>  */}
                                        <span className={styles.head_np} >{patientStateMap[detailData.state]}</span> 
                                        {
                                            detailData.patientLabel &&
                                            <span className={styles.head_np} >{detailData.patientLabel}</span> 
                                        }
                                    </div>
                                    <div className={styles.home_head_bottom}>{detailData.groupName}</div>
                                </div>
                                {
                                    detailData.patientLabel === 'IP' && 
                                    <div className={styles.outcome_register}>
                                        <div className={styles.outcome_wrap} onClick={() => {
                                            showOutCome();
                                        }}>
                                            <img className={styles.img_first} src={OutcomeRegister} alt="" />
                                            <div className={styles.outcome_word}>
                                                <div>转归</div>
                                                <div>登记</div>
                                            </div>
                                            <img className={styles.img_last} src={IconPlay} alt="" />
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={`${styles.followup_card_container}`} onScroll={followupCardScroll}>
                                {
                                    nodeList && nodeList.map((val: any, key: number) => (
                                        <div key={key} className={`${ key === indicatorCurIndex ? styles.followup_card_active : styles.followup_card_un_active }`} onClick={ () => { nodeListActive(key) }}>
                                            <div className={`${styles.followup_card_title}`}>{val.nodeName}</div>
                                            <div className={`${styles.followup_card_desc}`}>{`${val.planTime}${val.planRange ? val.planRange : ''}`}</div>  
                                        </div>
                                    ))
                                }
                            </div>
                            <div className={`${styles.followup_indicator}`}>
                                {
                                    nodeList && nodeList.map((val: any, key: number) => (
                                        <div key={key} className={`${key === indicatorCurIndex ? styles.followup_indicator_active : nodeList[key].state == 4 ? styles.followup_indicator_already_active : ''}`}></div>
                                    ))
                                }
                            </div>
                            <div className={`${styles.followup_gap}`}>
                            </div>
                            <div className={`${styles.current_followup_task}`}>
                                本次随访任务
                            </div>
                        </div>
                        {/* 本次随访任务 */}
                        <div className={`${styles.content_wrap_bottom}`}>
                        {
                            nodeList[indicatorCurIndex] && nodeList[indicatorCurIndex].tasks && (nodeList[indicatorCurIndex].tasks.length >= 0) ?
                            nodeList[indicatorCurIndex].tasks.map((val: any, key: number) => (
                            <div key={key} className={`${styles.followup_node_children_wrap}`} onClick={() => { nodeListItemClick(val, key) }}>
                                <div className={`${styles.node_childre_left}`}>
                                    <img src={followup_node_icon} alt="" />
                                </div>
                                <div className={`${styles.node_childre_middle}`}>
                                    <div className={`${styles.node_childre_middle_up}`}>{val.name}</div>
                                    <div className={`${styles.node_childre_middle_bottom}`}>
                                        {/* {nodeList[indicatorCurIndex].state == 4 ? '已完成' : nodeList[indicatorCurIndex].state == 1 ? '进行中' : nodeList[indicatorCurIndex].state == 0 ? '未开始' : ''} */}
                                        {val.state == 2 ? '已完成' : val.state == 1 ? '进行中' : val.state == 0 ? '未开始' : ''}
                                    </div>
                                </div>
                                <div className={`${styles.node_childre_right}`}>
                                    <img src={right_arrow} alt="" />
                                </div>
                            </div>
                            )
                            )
                            :
                            null
                            // <PatientHomeDetail detailData={detailData} inPrePage={true} activeIndex={indicatorCurIndex} />
                        }
                        {/* {
                            showCrf && props.children
                        } */}
                                                    
                       </div>
                    </div>
                    <div>
                        <div className={styles.home_avatar_container} style={{backgroundImage: `url(${patient_home_avatar_bg})`, backgroundSize: '100% 100%'}}>
                                <img className={styles.home_avatar} src={patient_home_avatar} alt="" />
                                <div className={styles.home_head_container}>
                                    <div className={styles.home_head_wrap} > 
                                        <span className={styles.head_title} >{detailData.patientName}</span> 
                                        {/* <span className={styles.head_referral} >已转诊</span>  */}
                                        <span className={styles.head_np} >{patientStateMap[detailData.state]}</span> 
                                        {
                                            detailData.patientLabel &&
                                            <span className={styles.head_np} >{detailData.patientLabel}</span> 
                                        }
                                    </div>
                                    <div className={styles.home_head_bottom}>{detailData.groupName}</div>
                                </div>
                        </div>
                        <BasicArchives allData={detailData} />
                    </div>
                    <div>
                        <div className={styles.home_avatar_container} style={{backgroundImage: `url(${patient_home_avatar_bg})`, backgroundSize: '100% 100%'}}>
                                <img className={styles.home_avatar} src={patient_home_avatar} alt="" />
                                <div className={styles.home_head_container}>
                                    <div className={styles.home_head_wrap} > 
                                        <span className={styles.head_title} >{detailData.patientName}</span> 
                                        {/* <span className={styles.head_referral} >已转诊</span>  */}
                                        <span className={styles.head_np} >{patientStateMap[detailData.state]}</span> 
                                        {
                                            detailData.patientLabel &&
                                            <span className={styles.head_np} >{detailData.patientLabel}</span> 
                                        }
                                    </div>
                                    <div className={styles.home_head_bottom}>{detailData.groupName}</div>
                                </div>
                        </div>
                        <InformedArchives allData={detailData} />
                    </div>
                </Tabs>
            }
        </div>
    )

}

export default Personal;